module.exports = __webpack_public_path__ + "media/images/favicons/icon-32x32-932e3ee2365e42a0891a9b81713fd187.png";